import { CAPTURE_CONTACTS } from 'constants/ActionTypes';

export function captureConcats( caseId ) {
  return {
    type    : CAPTURE_CONTACTS,
    payload : caseId
  };
}
